import { render } from "./StepSocials.vue?vue&type=template&id=85528480"
import script from "./StepSocials.vue?vue&type=script&lang=js"
export * from "./StepSocials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__